import { DateTime, Settings } from 'luxon';
import { useTranslation } from 'react-i18next';

export const useLuxon = () => {
  const { i18n } = useTranslation();
  Settings.defaultLocale = i18n.language;

  return { DateTime, Settings };
};
